import { isE2E } from './utils';

(function () {
  const targetEnvironment = import.meta.env.VITE_TARGET_ENV;
  const shellBuildVersion = import.meta.env.VITE_SHELL_BUILD_VERSION;
  const shouldLoadE2EConfig = isE2E() || targetEnvironment === 'e2e';
  const cacheBuster = shellBuildVersion ? `?v=${encodeURIComponent(shellBuildVersion)}` : '';

  if (shouldLoadE2EConfig) {
    const script = document.createElement('script');
    script.src = `/c_e2e.js${cacheBuster}`;
    document.body.appendChild(script);
  } else {
    const script = document.createElement('script');
    script.src = `/c.js${cacheBuster}`;
    document.body.appendChild(script);
  }
})();
